import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import OrbitalPiercingImage from '../../Assets/Piercing Services/orbital piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function OrbitalPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Orbital Piercing UAE | 200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Orbital Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Orbital Piercing 200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={OrbitalPiercingImage} alt="Orbital Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Orbital Piercing</h3>

          <p>
            Upgrade your ear styling with our professional orbital piercing services in the UAE, available at an affordable price of 200 AED. Orbital piercing is a unique and eye-catching ear piercing style that features two separate holes connected by a single ring, creating a circular and modern look that stands out beautifully. This distinctive design adds a bold yet elegant touch to your appearance, making it a popular choice for individuals who want something different from traditional single piercings. Whether placed on the lobe or cartilage, orbital piercing offers versatility and creativity, allowing you to express your personal style with confidence.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each orbital piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Since orbital piercing involves two connected piercings, it requires expert alignment and accuracy, and our experienced specialists are trained to deliver perfectly balanced results while minimizing discomfort.
          </p>

          <p>
            Orbital piercing is ideal for those who want a bold and stylish ear design that is both modern and unique. Its connected ring design creates a seamless and cohesive look, making it perfect for individuals who enjoy statement jewelry and creative styling. This piercing pairs well with other ear piercings such as helix, conch, or lobe, allowing you to build a curated and layered ear aesthetic. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry size to achieve the desired look.
          </p>

          <p>
            The procedure is typically completed within a short time, making it convenient for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, ensuring that you can enjoy your new piercing without unnecessary stress. We also provide high-quality, hypoallergenic rings that are safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that double piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is an essential part of maintaining your orbital piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your orbital piercing will heal effectively and remain a stylish and long-lasting addition to your look.
          </p>

          <p>
            Our orbital piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted orbital piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a unique and modern ear look effortlessly. Book your orbital piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Orbital Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default OrbitalPiercing;